var React = require('react');

function ArrowUpBlueInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#","strokeWidth":"1.05","d":"M21 11 11 .888 1 11"}));
}

ArrowUpBlueInline.defaultProps = {"width":"22","height":"12"};

module.exports = ArrowUpBlueInline;

ArrowUpBlueInline.default = ArrowUpBlueInline;
